import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep} from "../../../../redux/actions/tourActions";
import {STEPS} from "../../helpers";
import {Tour} from "antd";
import AiMeetingReviewStep from "../AIMeetingReviewStep/AIMeetingReviewStep";
import {useTourActions} from "../../hooks";
import FavoritesTeamNotes from "../FavoritesTeamNotes/FavoritesTeamNotes";

const TourThreeStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const channels = useSelector(state => state.channels?.channels || []);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const {handleClickNextStep3} = useTourActions();

    useEffect(() => {
        if ([STEPS.THREE].includes(activeStep)) {
            setTimeout(() => {
                setIsOpen(true)
            }, 1000)
        } else if ([STEPS.THREE_NEXT_TWO].includes(activeStep)) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }
    }, [activeStep])

    const steps = [
        {
            title: t('tour_step_3'),
            description: t('tour_step_3_desc'),
            target: () => document.querySelector(`.video_details__top--container`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => dispatch(UpdateActiveStep(STEPS.THREE_NEXT_TWO))
            },
            placement: 'center'
        },
        {
            title: t('tour_step_3_1'),
            description: <AiMeetingReviewStep/>,
            target: () => document.querySelector(`.allotment-pane-right`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
            },
            placement: 'left'
        },
        {
            title: t('tour_step_3_2'),
            description: <FavoritesTeamNotes/>,
            target: () => document.querySelector(`.allotment-pane-left`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => handleClickNextStep3()
            },
            placement: 'right'
        }
    ];

    return (
        <Tour
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false)
            }}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourThreeStep;